export enum DocumentType {
  T4 = "T4",
  NOA = "NOA",
  PAYSTUB = "PAYSTUB",
  BANK_STATEMENT = "BANK_STATEMENT",
  MLS = "MLS",
  CLOSING_DOCUMENT = "CLOSING_DOCUMENT",
}
